// UTM params a donor arrived with, read straight off the current URL. Shared by
// the abandoned-form capture (useAbandonedForm) and the donation pages, which
// attach the same fields to the 'initiated' log-donation event so a completed
// gift can be attributed in Gramsci too.
export function readUtmParams() {
  const p = new URLSearchParams(window.location.search);
  return {
    utmSource: p.get('utm_source') || '',
    utmMedium: p.get('utm_medium') || '',
    utmCampaign: p.get('utm_campaign') || '',
    utmTerm: p.get('utm_term') || '',
    utmContent: p.get('utm_content') || '',
  };
}
